import * as React from 'react';

import cx from 'classnames';

// @ts-ignore
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Header from 'components/Header';
import Link from 'components/Link';

import './styles/MarketingLayout.scss';

type Props = {
  location: any;
  children?: React.ReactNode;
  borderless?: boolean;
};

function getUserIdentifier(): string {
  const user = CurrentUser.getUser();
  return user.getSignature() || user.getEmail() || user.get('default_phone_number').pretty || '';
}

function MarketingLayout(props: Props) {
  return (
    <div className="MarketingLayout">
      <div className="MarketingLayout-headerContainer">
        <div
          className={cx('MarketingLayout-header', {
            'MarketingLayout-header--border': !props.borderless,
          })}>
          <Header data-test="header" location={props.location} />
        </div>
      </div>
      <div className="MarketingLayout-content">
        {props.children}

        {CurrentUser.isSignedIn() ? (
          <BoxFooter>
            Logged in as {getUserIdentifier()}
            <br />
            Not you? <Link onClick={() => AuthActions.signOut(undefined, true)}>Log out</Link>
          </BoxFooter>
        ) : null}
      </div>
    </div>
  );
}

export default MarketingLayout;
